export default class UserAccountModel {
    constructor() {
        this.account_id = null;
        this.user_id = null;
    }
}